import PropTypes from 'prop-types';

import contentVersionPropType from './contentVersionPropType';

const contentGroupPropType = PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    gpi10: PropTypes.string,
    contentVersions: PropTypes.oneOfType([
        PropTypes.arrayOf(contentVersionPropType),
        PropTypes.objectOf(contentVersionPropType),
    ]).isRequired,
    children: PropTypes.objectOf(contentVersionPropType),
});

export default contentGroupPropType;
